import './CardDiagnosisProcedure.scss'
import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import {
  deleteFromSettingsServer,
  postToSettingsFavDiag,
  putSettingsForSingleParam,
} from 'src/apiHelper/settingsApi'
import { useDispatch } from 'react-redux'
import { CButton, CFormCheck, CTooltip } from '@coreui/react-pro'
import Loader from '../Loader/Loader'
import { useState } from 'react'
import PickListCPT from '../PickListCPT'
import { doesCPTRequireModifier } from '../shared/sharedCPTLogic'
import { isMainDxInvalid, generateMainDXInvalidMessage } from '../shared/sharedDXLogic'
import { SETTINGS_URL } from '../../../apiHelper/apiRoute/settings'
import { getProviderFavDX, getProviderFavCPT } from '../../../redux/user/userThunk'
import { validateCPTDate } from '../../../helper/formater'
import { WHITE } from '../../../scss/colorConsts'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'

const ERROR_STYLES = { color: getIsAi() ? 'var(--color-warning)' : 'red', fontSize: '0.8em' }

export default function CardDiagnosisProcedure({
  item,
  handleAddRemove,
  onModifierAdd,
  serviceDate,
  icon,
  index,
  toggleFavorite = false,
  selectedList = [],
  type,
  isReadOnly,
  innerRef,
  isVisitHistory,
  isBillSummary = false,
  showDescription = false,
  isBillingSummaryDisabled,
  dxDisplayTags,
  panelSelected = false,
  hideModifier = false,
  isAI = false,
  ...rest
}) {
  const dispatch = useDispatch()
  const provFavCPTs = useSelector((state) => state.user?.providerFavCPT)
  const provFavDX = useSelector((state) => state.user?.providerFavDX)

  const [isLoading, setIsLoading] = useState(false)
  const [modifierVisible, setModifierVisible] = useState(false)
  const isSelectedProcedureCode = icon === 'minus'

  const [unitsInput, setUnitsInput] = useState(item?.units || 1)
  const [selectedProcedureModifiers, setSelectedProcedureModifiers] = useState(
    item?.modifiers || [],
  )

  const isValid = validateCPTDate(item, serviceDate)

  useEffect(() => {
    if (isSelectedProcedureCode && item?.modifiers) {
      setSelectedProcedureModifiers(item?.modifiers)
    }
  }, [item?.modifiers, isSelectedProcedureCode])

  const processFavoritesUpdate = async (updatePromise, callback) => {
    return await updatePromise
      .then(async (res) => {
        if (res?.status === 'success') {
          await callback()
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const handleFav = async (item) => {
    setIsLoading(true)
    if (type === 'DIAGNOSIS') {
      if (!provFavDX[item?.code]) {
        await processFavoritesUpdate(
          postToSettingsFavDiag(SETTINGS_URL.FAV_DIAGNOSIS, [item?.code]),
          () => dispatch(getProviderFavDX()),
        )
      } else {
        await processFavoritesUpdate(
          deleteFromSettingsServer(SETTINGS_URL.FAV_DIAGNOSIS + '/' + item?.code),
          () => dispatch(getProviderFavDX()),
        )
      }
    } else if (type === 'PROCEDURE') {
      if (!provFavCPTs[item?.code]) {
        await processFavoritesUpdate(
          putSettingsForSingleParam(SETTINGS_URL.FAV_PROCEDURE + item?.code),
          () => dispatch(getProviderFavCPT()),
        )
      } else {
        await processFavoritesUpdate(
          deleteFromSettingsServer(SETTINGS_URL.FAV_PROCEDURE + item?.code),
          () => dispatch(getProviderFavCPT()),
        )
      }
    }
    setIsLoading(false)
  }

  const onModifierSave = () => {
    if (unitsInput === '') {
      setUnitsInput(1)
    }
    onModifierAdd({ ...item, modifiers: selectedProcedureModifiers, units: unitsInput || 1 }, index)

    setModifierVisible(false)
  }

  return (
    <div className="addedDiagnosis-newdesign" ref={innerRef} {...rest}>
      {isLoading && <Loader />}
      {toggleFavorite ? (
        <div
          className={`content_list_itemIcon-diagnosiscode-newdesign justify-content-center align-items-center ${
            provFavCPTs[item?.code] || provFavDX[item?.code] ? 'favourite' : ''
          }`}
          // TODO debounce
          onClick={() => handleFav(item)}
        >
          <i className="fa-solid fa-star" style={{ fontSize: '0.8em' }}></i>
        </div>
      ) : (
        <div className="card-left-space"></div>
      )}

      <div
        className="content-sec-code"
        style={{ flexDirection: 'column', marginLeft: getIsAi() ? '8px' : '30px' }}
      >
        <div
          style={{
            display: 'flex',
            paddingTop: modifierVisible ? '4px' : '0px',
            gap: `${(item?.modifiers?.length || 0) * 8}px`,
          }}
        >
          {getIsAi() && (
            <i
              className="fa-solid fa-grip-lines"
              style={{
                display: 'flex',
                alignItems: 'center',
                paddingRight: '2px',
                color: 'lightslategray',
                cursor: 'grab',
              }}
            ></i>
          )}
          <div
            className={`addedDiagnosisInfo-newdesign d-flex`}
            style={{
              justifyContent: item?.modifiers?.length > 0 ? 'flex-start' : 'space-evenly',
              marginRight: '6px',
            }}
          >
            <div
              className={
                type === 'PROCEDURE' && selectedList?.some((ele) => ele?.code === item?.code)
                  ? `addedDiagnosisText-newdesign`
                  : ''
              }
              title={showDescription ? item.description : undefined}
              style={{
                flexDirection: isBillingSummaryDisabled
                  ? 'row'
                  : item?.modifiers?.length > 0
                    ? 'column'
                    : 'row',
                gap: isBillingSummaryDisabled ? '4px' : '',
              }}
            >
              <span className={`${isAI ? 'ai' : ''}`}>
                {type === 'DIAGNOSIS' || isVisitHistory || isBillSummary
                  ? item.code.length > 3
                    ? [item.code.slice(0, 3), '.', item.code.slice(3)].join('')
                    : item.code
                  : item.code}
              </span>

              {isReadOnly && item?.modifiers?.length > 0 && (
                <span>{':' + item?.modifiers.join(',')}</span>
              )}

              <div className="mods-units-text-title">
                {type === 'PROCEDURE' &&
                  item?.modifiers?.length > 0 &&
                  selectedList?.some((ele) => ele?.code === item?.code) && (
                    <div>{':' + item?.modifiers.join(',')}</div>
                  )}

                {type === 'PROCEDURE' && item?.units > 1 && <div>{'(' + item?.units + ')'}</div>}
              </div>
            </div>
            {!isValid && (
              <CTooltip content={`Code is not valid for visit date of service`}>
                <i className="fa-solid fa-triangle-exclamation" style={ERROR_STYLES}></i>
              </CTooltip>
            )}

            {/* If icon is minus, it means it is an attached/chosen code :'( */}
            {icon === 'minus' && doesCPTRequireModifier(item) && (
              <CTooltip content={`Modifier Required`}>
                <i
                  className="fa-solid fa-triangle-exclamation"
                  style={{ ...ERROR_STYLES, marginRight: isValid ? '4px' : '0' }}
                ></i>
              </CTooltip>
            )}
            {icon === 'minus' && index === 0 && isMainDxInvalid([item]) && (
              <CTooltip content={generateMainDXInvalidMessage([item])}>
                <i
                  className="fa-solid fa-triangle-exclamation"
                  style={{ ...ERROR_STYLES, marginRight: isValid ? '4px' : '0' }}
                ></i>
              </CTooltip>
            )}
          </div>
          <div
            className="right-sec"
            style={
              modifierVisible ? { marginRight: '14px' } : getIsAi() ? { paddingLeft: '16px' } : {}
            }
          >
            {showDescription && (
              <div className={'trimTextDescr'} title={item.description}>
                {item?.description}
              </div>
            )}
            {/* this section is always hidden, but may one day be turned back on */}
            <div className={`addedDiagnosisPara-newdesign me-1`}>
              <small>
                {!showDescription && item.description}
                {type === 'DIAGNOSIS' &&
                  (item.pdpm_clinical_category &&
                  item.pdpm_clinical_category !== 'Return to Provider' &&
                  !item.pdpm_snf_comment ? (
                    <small className="pdpm-text">
                      &nbsp;- PDPM &nbsp;
                      <i className="fa-solid fa-check is-mapped" style={{ fontSize: '1.5em' }}></i>
                    </small>
                  ) : (
                    item.pdpm_clinical_category &&
                    (item.pdpm_clinical_category === 'Return to Provider' ||
                      item.pdpm_snf_comment) && (
                      <small>
                        &nbsp;- PDPM
                        <i
                          className="fa-solid fa-triangle-exclamation"
                          style={{ fontSize: '1.4em', color: WHITE, marginLeft: '4px' }}
                        ></i>
                      </small>
                    )
                  ))}
                {type === 'DIAGNOSIS' && Boolean(item?.nta_points) && (
                  <small>&nbsp; NTA: {item?.nta_points}</small>
                )}
                {dxDisplayTags && (
                  <div className={'panel-tag'}>
                    {dxDisplayTags?.map((tag) => {
                      return <div key={tag}>{tag}</div>
                    })}
                  </div>
                )}
              </small>
            </div>

            {panelSelected ? (
              <i
                className="fa-regular fa-trash-can cardDiagnosisProcedureTrash"
                onClick={() => {
                  handleAddRemove(item)
                }}
              ></i>
            ) : (
              <CFormCheck
                class="cardDiagnosisProcedureCheckbox"
                checked={icon === 'minus'}
                onChange={() => {
                  handleAddRemove(item)
                }}
              />
            )}

            {type === 'PROCEDURE' &&
              !hideModifier &&
              isSelectedProcedureCode &&
              selectedList?.some((ele) => ele?.code === item?.code) && (
                <div className="mod-txt">
                  <CButton
                    color="primary"
                    variant="ghost"
                    className="mod-btn"
                    onClick={() =>
                      modifierVisible ? setModifierVisible(false) : setModifierVisible(true)
                    }
                    style={modifierVisible ? {} : { marginRight: '15px' }}
                  >
                    <i
                      className={
                        modifierVisible ? 'fa-light fa-angle-down' : 'fa-light fa-angle-left'
                      }
                      style={{ fontSize: '2em' }}
                    ></i>
                  </CButton>
                </div>
              )}
          </div>
        </div>
        {modifierVisible && (
          <div>
            <div className="modifier-holder ">
              <div className="mods-holder">
                <div className="mods-units-holder">
                  <div className="mods-label">Mods</div>
                  <div className="cpt-pick-list">
                    {type === 'PROCEDURE' &&
                      selectedList?.some((ele) => ele?.code === item?.code) && (
                        <PickListCPT
                          key={item}
                          item={item}
                          setSelectedProcedureModifiers={setSelectedProcedureModifiers}
                          selectedProcedureModifiers={selectedProcedureModifiers}
                        />
                      )}
                  </div>
                </div>
                <div className="units-holder">
                  <div className="units-label">Units</div>
                  <input
                    className="units-input"
                    type="text"
                    id="units"
                    value={unitsInput}
                    onChange={(e) =>
                      e.target.value === '' || /[^0-9]/i.test(String(e.target.value))
                        ? setUnitsInput('')
                        : Number(e.target.value) > 999
                          ? setUnitsInput(999)
                          : Number(e.target.value) < 1
                            ? setUnitsInput(1)
                            : setUnitsInput(Number(e.target.value))
                    }
                  />
                </div>
              </div>
              <div className="action-holder">
                <div className="action-link" onClick={onModifierSave}>
                  Save
                </div>
                <div
                  className="action-link"
                  onClick={() => {
                    setSelectedProcedureModifiers(item?.modifiers || [])
                    setModifierVisible(false)
                    setUnitsInput(item?.units || 1)
                  }}
                >
                  Cancel
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
